import actionCreatorFactory from "../util/redux/action-factory";
import { reducerWithInitialState } from "../util/redux/typed-reducers";
import { ReduxDispatch, ReduxState } from "./reducers";
import * as request from "../util/request";
import { env } from "../util/env";
import logger from "../util/logger";
import { SubjectCategoryDto } from "../util/DTOs/SubjectCategoryDtos";

const actionFactory = actionCreatorFactory("HypoMobiili/SubjectCategories");
const getSubjectCategoriesAction = actionFactory<
    {},
    SubjectCategoryDto[],
    string
>("GET_SUBJECT_CATEGORIES");

export class SubjectCategoriesState {
    loading: boolean;
    subjectCategories: SubjectCategoryDto[];
}

const initialState: SubjectCategoriesState = {
    loading: false,
    subjectCategories: [],
};

export function fetchSubjectCategories() {
    return async (dispatch: ReduxDispatch) => {
        try {
            dispatch(getSubjectCategoriesAction({}));

            const result = await request.get<Array<SubjectCategoryDto>>(
                `${env.APP_API_HOST}/api/messageThreads/categories`
            );

            dispatch(getSubjectCategoriesAction.done(result));
        } catch (error) {
            dispatch(
                getSubjectCategoriesAction.failed("Error loading categories")
            );
            logger.error(error);
            throw error;
        }
    };
}

export const SubjectCategoriesReducer = reducerWithInitialState(initialState)
    .case(getSubjectCategoriesAction, (state, action) => {
        return {
            ...state,
            loading: true,
        };
    })
    .case(getSubjectCategoriesAction.done, (state, action) => {
        return {
            ...state,
            loading: false,
            subjectCategories: action.payload,
        };
    })
    .case(getSubjectCategoriesAction.failed, (state, action) => {
        return {
            ...state,
            loading: false,
        };
    });

export default SubjectCategoriesReducer;

export const getCategories = (state: ReduxState) => {
    return state.subjectCategories.subjectCategories;
};



// WEBPACK FOOTER //
// ./src/ducks/subjectCategories.ts